/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconPointerDollar = createReactComponent("pointer-dollar", "IconPointerDollar", [
  [
    "path",
    {
      d: "M14.778 12.222l3.113 -2.09a1.2 1.2 0 0 0 -.309 -2.228l-13.582 -3.904l3.904 13.563a1.2 1.2 0 0 0 2.228 .308l2.09 -3.093l.787 .787",
      key: "svg-0"
    }
  ],
  [
    "path",
    {
      d: "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5",
      key: "svg-1"
    }
  ],
  ["path", { d: "M19 21v1m0 -8v1", key: "svg-2" }]
]);

export { IconPointerDollar as default };
//# sourceMappingURL=IconPointerDollar.js.map
